var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L13 30.5925L1 60","stroke":"#535B66","strokeWidth":"2"}));
}

RightArrow.defaultProps = {"width":"15","height":"61","viewBox":"0 0 15 61","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
